<div class="main-wrapper">
    <!-- <button mat-flat-button class="lang-btn" (click)="changeLanguage()">
        {{ 'general.language' | translate }}
    </button> -->
    <router-outlet></router-outlet>
</div>